import { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { cn } from '../../utils/classNames';
import logo from '../../assets/baconbee-logo.svg';
console.log('🔥 Loaded: Dashboard Layout');
const navItems = [
  { name: 'Projects', path: '/dashboard/projects' },
  { name: 'Messages', path: '/dashboard/messages' },
  { name: 'Files', path: '/dashboard/files' },
  { name: 'Settings', path: '/dashboard/settings' },
];

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="flex min-h-screen bg-[#FFF8EC]">
      {/* Sidebar */}
      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-30 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full',
          'lg:translate-x-0'
        )}
      >
        <div className="flex items-center justify-between p-4 border-b">
          <img src={logo} alt="BaconBee Logo" className="h-8" />
          <button
            className="lg:hidden"
            onClick={() => setSidebarOpen(false)}
            aria-label="Close sidebar"
          >
            <X className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        <nav className="p-4 space-y-2">
          {navItems.map(({ name, path }) => (
            <Link
              key={path}
              to={path}
              className={cn(
                'block px-4 py-2 rounded-xl font-medium',
                location.pathname.startsWith(path)
                  ? 'bg-[#F95F53] text-white'
                  : 'text-gray-800 hover:bg-gray-100'
              )}
              onClick={() => setSidebarOpen(false)}
            >
              {name}
            </Link>
          ))}
        </nav>
      </aside>

      {/* Main Content */}
      <div className="flex-1 lg:ml-64">
        {/* Top Navbar */}
        <header className="flex items-center justify-between px-6 py-4 bg-white border-b shadow-sm">
          <button
            className="lg:hidden"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open sidebar"
          >
            <Menu className="w-6 h-6 text-gray-700" />
          </button>
          <h1 className="text-xl font-bold text-[#F95F53]">BaconBee Dashboard</h1>
        </header>

        {/* Page Content */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}